import React from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ children, className }) => {
  // Usamos el hook useState para manejar la creación y destrucción del div que contendrá el modal
  const [container] = React.useState(() => {
    const div = document.createElement('div');
    if (className) {
      div.className = className; // Asigna la clase al div
    }
    return div;
  });

  React.useEffect(() => {
    // Obtener el nodo del DOM donde se montará el portal
    const modalRoot = document.getElementById('modal-root');
    modalRoot.appendChild(container);

    // Cuando el componente se desmonte, limpiar el nodo del DOM
    return () => {
      modalRoot.removeChild(container);
    };
  }, [container]);

  // Creamos el portal utilizando el contenedor y renderizando los children dentro
  return ReactDOM.createPortal(children, container);
};

export default Modal;
